var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { memo } from 'react';
import { AddButton, AddButtonWithTooltip, DownloadButton } from '../Buttons';
import { classLinkText, cleverText } from '../Common';
import { getDownloadPasswordsUrl } from '../api';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-1ubgmiw" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: ", ";\n\n  margin-bottom: ", ";\n\n  & > :not(:last-child) {\n    margin-right: ", ";\n  }\n"], ["\n  display: flex;\n  justify-content: ", ";\n\n  margin-bottom: ", ";\n\n  & > :not(:last-child) {\n    margin-right: ", ";\n  }\n"])), function (_a) {
    var isUpperPanel = _a.isUpperPanel;
    return isUpperPanel ? 'end' : 'space-between';
}, function (_a) {
    var isUpperPanel = _a.isUpperPanel;
    return (isUpperPanel ? '16px' : '40px');
}, function (_a) {
    var isUpperPanel = _a.isUpperPanel;
    return (isUpperPanel ? '16px' : '0');
});
var ButtonsPanel = function (_a) {
    var shouldShowAddButton = _a.shouldShowAddButton, isUpperPanel = _a.isUpperPanel, onAdd = _a.onAdd, groupId = _a.groupId, tooltipText = _a.tooltipText;
    var url = getDownloadPasswordsUrl(groupId);
    return (_jsxs(Container, __assign({ isUpperPanel: isUpperPanel }, { children: [shouldShowAddButton &&
                (tooltipText ? (_jsx(AddButtonWithTooltip, { tooltipText: tooltipText, title: 'Add another student', onClick: onAdd }, void 0)) : (_jsx(AddButton, { title: 'Add another student', onClick: onAdd }, void 0))), _jsx(DownloadButton, { url: url }, void 0)] }), void 0));
};
var ButtonsPanelContainer = memo(function (_a) {
    var groupType = _a.groupType, rest = __rest(_a, ["groupType"]);
    return {
        manual: _jsx(ButtonsPanel, __assign({}, rest), void 0),
        clever: _jsx(ButtonsPanel, __assign({ tooltipText: cleverText }, rest), void 0),
        classLink: _jsx(ButtonsPanel, __assign({ tooltipText: classLinkText }, rest), void 0),
    }[groupType];
});
export { ButtonsPanelContainer as ButtonsPanel };
var templateObject_1;
